import { IExternalPicture } from 'shared/types/ExternalPicture';
import { normalizeValue } from 'shared/utils/normalizeValue';

const sneakersAltTag = [
  'Right side view of',
  'Right side detail view of',
  'Left side view of',
  'Bottom sole view of',
  'Bottom sole detail view of',
  'Back view',
  'Back detail view of',
];

const apparelAltTag = ['Front view of', 'Back view of', 'Detail view of'];

export const addAltTagToProductTemplateCarouselImages = ({
  images,
  name,
  productCategory,
}: {
  images: IExternalPicture[];
  name: string;
  productCategory: string;
}) => {
  switch (productCategory) {
    case 'shoes':
      return images?.map((img, idx) => ({
        ...img,
        altText: `${sneakersAltTag[idx]} ${normalizeValue(name)}`,
      }));
    case 'clothing':
      return images?.map((img, idx) => ({
        ...img,
        altText: `${apparelAltTag[idx]} ${normalizeValue(name)}`,
      }));
    default:
      return images?.map((img, idx) => ({
        ...img,
        altText: `View ${idx + 1} of ${normalizeValue(name)}`,
      }));
  }
};
